import { LocaleModule } from "@/core/modules/locale/objects/LocaleModule";

import { en } from "./en";
import { it } from "./it";

export const utilityExportEmployeeLocaleModule: LocaleModule = {
  name: "utilityExportEmployee",
  messages: { en: en, it: it },
};
